import { customAlphabet } from 'nanoid';

const BODY_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
const BODY_LENGTH = 10;
const generateBody = customAlphabet(BODY_ALPHABET, BODY_LENGTH);

export const FAMILY_PREFIX_AUTO = 'a_';
export const FAMILY_PREFIX_USER = 'u_';

/**
 * Remove the a_/u_ prefix used to encode FamilyID provenance.
 * Two products with the same body but different prefixes are in the same
 * conceptual family (one auto-placed, one user-curated into the same group).
 */
export function stripFamilyPrefix(familyId: string): string {
  if (familyId.length < 2) {
    return familyId;
  }

  if (familyId.startsWith(FAMILY_PREFIX_AUTO) || familyId.startsWith(FAMILY_PREFIX_USER)) {
    return familyId.slice(2);
  }

  return familyId;
}

/** Mint a fresh user-owned FamilyID (Remove creates a new singleton family). */
export function newUserFamilyId(): string {
  return FAMILY_PREFIX_USER + generateBody();
}

/** Build a user-owned FamilyID targeting an existing body (Add / Move). */
export function userFamilyIdForBody(body: string): string {
  return FAMILY_PREFIX_USER + body;
}
